import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  DC_SAPI_Apigee_HemsSessionsV2_RequestModels_DetailedGranularity,
  RequestModels_Hems_CaptarThresholdRequestModel,
  RequestModels_Hems_SessionsAggregateV2PaginationRequestModel,
  RequestModels_Hems_SessionsV2RequestModel,
  ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_EvSessionAggregateResponse,
  ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_SessionDetailsResponseModel,
  ResponseModels_Hems_CaptarThresholdResponseModel,
  ResponseModels_Hems_v2_EvSessionResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetSessionsV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  deviceId: string;
  requestBody?: RequestModels_Hems_SessionsV2RequestModel;
};
/**
 * Gets the sessions for a specific device
 *
 * @returns ResponseModels_Hems_v2_EvSessionResponseModel Success
 */
export function getSessionsV2(
  { businessUnit, label, customerId, deviceId, requestBody }: GetSessionsV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Hems_v2_EvSessionResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/hems/v2/sessions/${deviceId}`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetSessionsAggregateV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  deviceId: string;
  requestBody: RequestModels_Hems_SessionsAggregateV2PaginationRequestModel;
};
/**
 * Gets the sessions aggregate for a specific device
 *
 * @returns ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_EvSessionAggregateResponse Success
 */
export function getSessionsAggregateV2(
  { businessUnit, label, customerId, deviceId, requestBody }: GetSessionsAggregateV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_EvSessionAggregateResponse> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/hems/v2/sessions/aggregate/${deviceId}`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetSessionDetailsV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  deviceId: string;
  sessionId: string;
  granularity: DC_SAPI_Apigee_HemsSessionsV2_RequestModels_DetailedGranularity;
};
/**
 * Gets the sessions aggregate for a specific device
 *
 * @returns ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_SessionDetailsResponseModel Success
 */
export function getSessionDetailsV2(
  { businessUnit, label, customerId, deviceId, sessionId, granularity }: GetSessionDetailsV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_SAPI_Apigee_HemsSessionsV2_ResponseModels_SessionDetailsResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/hems/v2/sessions/${deviceId}/${sessionId}/detailed`,
      query: { granularity },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type CreateOrUpdateCaptarThreshold = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  deviceId: string;
  requestBody: RequestModels_Hems_CaptarThresholdRequestModel;
};
/**
 * Create or update the captar threshold for a specific customer
 *
 * @returns ResponseModels_Hems_CaptarThresholdResponseModel Success
 */
export function createOrUpdateCaptarThreshold(
  { businessUnit, label, customerId, deviceId, requestBody }: CreateOrUpdateCaptarThreshold,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Hems_CaptarThresholdResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/hems/v2/captar/${deviceId}/threshold`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetCaptarThreshold = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  deviceId: string;
};
/**
 * Gets the captar threshold for a specific customer
 *
 * @returns ResponseModels_Hems_CaptarThresholdResponseModel Success
 */
export function getCaptarThreshold(
  { businessUnit, label, customerId, deviceId }: GetCaptarThreshold,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Hems_CaptarThresholdResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/hems/v2/captar/${deviceId}/threshold`,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
